/**
 * @desc AJS compliant router function to handle migration routes
 * @param {angular.$stateProvider} $stateProvider - Angular stateprovider to handle states
 * @return {void}
 */
export function BulkSettingsRouter($stateProvider) {
  $stateProvider
    .state('app.ops-support-settings', {
      url: '/ops-support/settings',
      template: '<app-bulk-settings></app-bulk-settings>',
    })
}



// WEBPACK FOOTER //
// ./src/app/ops-support/settings/bulk-settings.router.js